import { render, staticRenderFns } from "./ContentCollections.vue?vue&type=template&id=20764fe8&"
import script from "./ContentCollections.vue?vue&type=script&lang=js&"
export * from "./ContentCollections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports